<template>
  <footer class="main-footer">
    <div class="footer-container">
      <div class="footer-content" style="text-align: start;">
        <!-- Brand -->
        <div class="footer-column">
          <div class="footer-brand">
            <!-- <svg width="120" height="32" viewBox="0 0 120 32" fill="none">
              <circle cx="16" cy="16" r="14" fill="#F16825"/>
              <path d="M10 12h12v8H10z" fill="white"/>
              <text x="40" y="20" 
               font-size="18" font-weight="600" fill="white">ChooseApp</text>
            </svg> -->
            <div style="background-color: white;display: flex;align-items: center;">
              <!-- Logo Image -->
              <img
                src="@/assets/chooseapp-preview.png"
                alt="ChooseApp Logo"
                class="logo-img"
              />

              <!-- Brand Text -->
              <span class="brand-text">ChooseApp</span>
            </div>
            <p class="footer-tagline">
              India's most trusted cab booking platform
            </p>
          </div>
        </div>

        <!-- Company -->
        <div class="footer-column">
          <h3>Company</h3>
          <div class="footer-links">
            <button class="footer-link" @click="scrollToSection('about')">About Us</button>
            <button class="footer-link" @click="scrollToSection('contact-us')">Contact Us</button>
            <button class="footer-link">Careers</button>
          </div>
        </div>

        <!-- Legal -->
        <div class="footer-column">
          <h3>Legal</h3>
          <div class="footer-links">
            <button class="footer-link">Privacy Policy</button>
            <button class="footer-link">Terms & Conditions</button>
          </div>
        </div>

        <!-- Social -->
        <div class="footer-column">
          <h3>Stay Connected</h3>
          <div class="social-media">
            <a href="#" class="social-link">
              <!-- <span class="material-icons">facebook</span> -->
              <v-icon>mdi-facebook</v-icon>
            </a>
            <a href="#" class="social-link">
              <!-- <span class="material-icons">alternate_email</span> -->
              <v-icon class="material-icons">mdi-instagram</v-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "AppFooter",
  methods: {
    scrollToSection(sectionId) {
      // Navigate to home page first if not already there
      if (this.$route.path !== '/') {
        this.$router.push('/').then(() => {
          this.$nextTick(() => {
            this.performScroll(sectionId);
          });
        });
      } else {
        this.performScroll(sectionId);
      }
    },
    performScroll(sectionId) {
      // Add a small delay to ensure page has loaded before scrolling
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          // For "about" section, use a larger offset to account for hero section
          const headerOffset = sectionId === 'about' ? 400 : 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 200);
    }
  }
}
</script>

<style scoped>
.logo-img {
  height: 60px;
  width: auto;
  margin-right: 8px;
}
.brand-text {
  font-size: 26px;
  font-weight: 600;
  color: #005886;
  margin-top: 0px !important;
}
</style>